import { alpha } from "@mui/material/styles";

export function getSuccessContainedDarkTextSx(theme) {
  if (theme.palette.mode !== "dark") return {};

  return {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.getContrastText(theme.palette.success.main),
    "&:hover": {
      backgroundColor: alpha(theme.palette.success.main, 0.88),
    },
    "&.Mui-disabled": {
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled,
    },
  };
}
